import { action, loader } from "~/routes-server/register.server";
import { useLoaderData } from "@remix-run/react";
import WvRegisterForm from "~/components/organisms/WvRegisterForm";
import WvRegisterHelp from "~/components/organisms/WvRegisterHelp";
import { asText } from "@prismicio/helpers";

export { metaHelper as meta } from "~/lib/meta";
export { headers } from "@commercekit/remix/lib.server";
export { loader, action };
export { default as ErrorBoundary } from "~/components/atoms/GeneralErrorBoundary";

const Register = () => {
  const {
    content,
    businuessCusotmerAdvantagesSlice,
    branches,
    accountRegistrationInfo,
    captchaSiteKey,
    phoneCodeCountries,
  } = useLoaderData<typeof loader>();
  return (
    <div className="customer">
      <div className="container">
        <div className="breadcrumbs py-3 mb-3"></div>
        <div className="row">
          <div className="col-12 col-md-7">
            <h1 className="heading sans-serif mdl strong sans-serif underlined left pb-3 mb-3">
              {asText(content.title)}
            </h1>
            <WvRegisterForm
              branches={branches}
              accountRegistrationInfo={accountRegistrationInfo}
              captchaSiteKey={captchaSiteKey}
              phoneCodeCountries={phoneCodeCountries}
            />
          </div>
          <div className="col-12 col-md-5">
            <WvRegisterHelp
              businuessCusotmerAdvantagesSlice={
                businuessCusotmerAdvantagesSlice
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
